import React, {FC, PropsWithChildren, ReactNode} from "react";
import "./ui.css";

// One tone per meaning; always show a word with it, never colour alone.
export type StatusTone = "info" | "success" | "warning" | "error" | "neutral";

type StatusTagProps = PropsWithChildren<{
    tone?: StatusTone;
    icon?: ReactNode;
    className?: string;
    title?: string;
}>;

export const StatusTag: FC<StatusTagProps> = ({tone = "neutral", icon, className, title, children}) => (
    <span
        className={["ati-status-tag", `ati-status-tag--${tone}`, className].filter(Boolean).join(" ")}
        data-tone={tone}
        title={title}
    >
        {icon}
        {children}
    </span>
);
